"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  prdays: {
    index: 'index',
    itemid: 'itemid',
    pyear: 'pyear',
    stoped: 'stoped',
    stddays: 'stddays',
    slydays: 'slydays',
    remark: 'remark',
    add: 'add',
    del: 'del',
    edit: 'edit',
    print: 'print',
    table: 'table',
    stamp: 'stamp',
    enable: 'enable',
    stop: 'stop',
    payrollManagement: 'payroll Management',
    basicData: 'basic Data',
    payableDaysMaintenance: 'payable Days Maintenance',
    submitted: 'submitted',
    unSubmitted: 'un Submitted',
    hint: 'hint',
    confirm: 'confirm',
    cancel: 'cancel',
    delSuc: 'del Suc',
    delFail: 'del Fail',
    delCancel: 'del Cancel',
    selectOneData: 'select One Data',
    payableDaysMaintenanceData: 'payable Days Maintenance Data',
    save: 'save',
    submit: 'submit',
    yes: 'yes',
    no: 'no',
    goBack: 'goBack',
    cmt: 'cmt',
    basicInfo: 'basic Info',
    operateInfo: 'operate Info',
    createInfo: 'create Info',
    modifyInfo: 'modify Info',
    submitInfo: 'submit Info',
    message1: 'Please select the row to delete',
    message2: 'This operation will permanently delete the piece of data',
    message3: 'Your changes may not be saved',
    message4: 'Please enter the year of publication',
    message5: 'Release year cannot be less than 4 digits',
    message6: 'The number of days for payroll cannot be greater than 3 digits',
    message7: 'Successfully saved',
    message8: 'Failed to save',
    message9: 'abnormal',
    message10: 'close the window',
    message13: 'Please fill in the number of days paid',
    message14: 'Please fill in the number of working days',
    message15: 'Submitted data cannot be deleted',
    message16: 'The integer number of working days cannot be greater than 3 digits'
  }
};